module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?f1997a8aba8a498fe4032e3b56e871ca";